const CancelIcon = ({ color = '#DC2626' }) => (
  <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
    <circle cx="8" cy="8" r="6.5" stroke={color} strokeWidth="1.3" />
    <path d="m5.5 5.5 5 5M10.5 5.5l-5 5" stroke={color} strokeWidth="1.3" strokeLinecap="round" />
  </svg>
)

export default CancelIcon
